<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Indent/index.html')">订单管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>订单汇总</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="订单号">
				<el-input v-model="item.order_sn" placeholder="订单号" size="small"></el-input>
			</el-form-item>
			<el-form-item label="用户">
				<el-input v-model="item.nickName" placeholder="用户昵称/手机号" size="small"></el-input>
			</el-form-item>
			<el-form-item label="收件人">
				<el-input v-model="item.consignee" placeholder="收件人" size="small"></el-input>
			</el-form-item>
			<el-form-item label="店铺">
				<el-select v-model="item.storeId" clearable placeholder="请选择">
					<el-option v-for="item in options" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="datetimerange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="success" @click="excelOut" size="medium">导出</el-button>
			</el-form-item>
		</el-form>
<!--		<div class="btns">-->
<!--			<el-button type="primary" size="small" @click="batchShipmentModal = true" v-auth="['supplier/order/sendShip']">批量发货</el-button>-->
<!--		</div>-->
		<!--		数据是list 通过list展示-->
		<div class="list-box" :data="list">
			<div class="list-box-title">
				<span>商品</span>
				<span>所属</span>
				<span>买家</span>
				<span>收货地址</span>
				<span>支付/配送</span>
				<span>价格</span>
				<span>操作</span>
				<span>状态</span>
			</div>
			<div class="list-box-content">
				<div class="list" v-for="list in list">
					<div class="list-title">
						<span>{{list.created_date}}</span>
						<span>订单编号：{{list.order_sn}}</span>
					</div>
					<div class="list-content-box">
						<div class="list-content">
							<div class="different-box">
								<div class="different" v-for="attr in list.goods">
									<div class="thumb">
										<img :src="attr.pic_url"  width="70px" height="70px" style="height: 70px">
										<div class="goods-text">
											<span>{{attr.product_name}}</span>
											<span>{{attr.sku_name}}</span>
										</div>
									</div>
									<div>
										<span>￥{{attr.price}} </span>
										<span>&nbsp;x&nbsp;{{attr.number}}</span>
									</div>
								</div>
							</div>
							<div>
								<span>{{list.store ? list.store.name : ''}}</span>
							</div>
							<div>
								<span>{{list.buyer ? list.buyer.nick_name : ''}}</span>
								<span>{{list.buyer ? list.buyer.mobile : ''}}</span>
							</div>
							<div>
								<p>收货人：<span class="color-blue">{{list.consignee}}</span></p>
								<p>买家手机：<span>{{list.mobile}}</span>
								<p>收货地址：<span class="color-blue">{{list.address}}</span>
								</p>
								<el-button class="copy-text" size="mini" type="primary" :data-clipboard-text="list.consignee + ' ' + list.mobile +  ' ' + list.address + ' '"  @click="copy">一键复制</el-button>
							</div>
							<div>
								<span> {{list.pay_type == 1 ? '微信支付' : '余额支付'}}</span>
							</div>
							<div>
								<span>￥{{list.order_price}}</span>
							</div>
							<div>
								<span class="list-booton-edit clike-cursor" @click="edit(list.id)">查看详情</span>
<!--								<span class="list-booton-edit">物流信息</span>-->
								<el-button size="mini" type="default" @click="open(list.id)" v-if="list.order_status == 2" v-auth="['supplier/order/sendShip']">
									发货
								</el-button>
								<el-button size="mini" type="default" @click="confirmcancel(list.id)" v-if="list.order_status == 21" v-auth="['supplier/order/audit']">
									去审核
								</el-button>
								<el-button size="mini" type="primary" @click="push(list.id)">推送</el-button>
								<el-button class="ml20" type="info" size="small"
										   @click="openLogistics(list.id)" v-if="list.delivery_status == 1">物流查询</el-button>
							</div>
							<div>
								{{list.state_text}}
							</div>
						</div>
					</div>
					<div class="list-booton">
						<!-- <span>1级佣金 </span>&nbsp;0&nbsp;元&nbsp;
						<span>2级佣金 </span>&nbsp;0&nbsp;元&nbsp;
						<span class="list-booton-edit">修改佣金 </span> -->
					</div>
				</div>
			</div>
		</div>

		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="limit"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		<el-dialog title="订单发货" :visible.sync="dialogFormVisible">
			<el-form label-position="right" :model="form" label-width="auto">
				<el-form-item label="收货人" v-if="order">
					{{order.consignee}}
				</el-form-item>
				<el-form-item label="买家手机"  v-if="order">
					{{order.mobile}}
				</el-form-item>
				<el-form-item label="收货地址"  v-if="order">
					{{order.address}}
				</el-form-item>
				<el-form-item label="物流公司">
					<el-select v-model="form.express_id" clearable placeholder="请选择物流公司">
						<el-option v-for="item in express" :value="item.id" :label="item.express_name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="物流单号">
					<el-input clearable v-model="form.express_sn" placeholder="请输入物流单号"/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" @click="send">发货</el-button>
			</div>
		</el-dialog>
		<el-dialog
				:visible.sync="batchShipmentModal"
				title="批量发货"
				class="paymentFooter"
				:show-close="true"
				width="540px"
				@closed="changeModal">
			<el-alert type="warning" :closable="false">
				<p>步骤一 导出发货单</p>
				<p>步骤二 发货单中填写物流单号</p>
				<p>步骤三 将发货单上传</p>
			</el-alert>
			<div class="acea-row row-middle mb10 mt10">
				<el-link
						type="primary"
						:underline="false"
						:href="'/files/delivery.xlsx'"
						target="_blank">
					<el-button>模板下载</el-button>
				</el-link>
				<div class="pl20 tips"></div>
			</div>
			<el-upload
					class="upload-demo"
					accept=".doc,.docx,.xls,.xlsx"
					drag
					:headers="header"
					:action="app_url + '/supplier/order/batchDelivery'"
					:on-success="(value) => uploadSuccess1( value)">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">批量发货单,拖入上传或<em>点击上传</em></div>
			</el-upload>
		</el-dialog>
		<el-dialog :visible.sync="modal2" v-if="modal2" scrollable
				   title="物流查询" width="350" class="order_box2">
			<div class="logistics acea-row row-top">
				<div class="logistics_img"><img src="@/assets/images/expressi.jpg"></div>
				<div class="logistics_cent" v-if="expressInfo">
					<span>物流公司：{{expressInfo.express_company}}</span>
					<span class="ml20">物流单号：{{expressInfo.express_sn}}</span>
				</div>
			</div>
			<div class="acea-row row-column-around trees-coadd mt50">
				<div class="scollhide">
					<el-timeline :reverse="reverse">
						<el-timeline-item
								v-for="(item,i) in result"
								:key="index"
								:timestamp="item.time">
							{{item.context}}
						</el-timeline-item>
					</el-timeline>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import Clipboard from "clipboard";

	export default {
		name: 'index',
		data() {
			return {
				form: {},
				dialogFormVisible: false,
				list: [],
				isLoad: false,
				pageNum: 0,
				limit: 20,
				total: 0,
				page: 1,
				// 查询
				item: {
					order_status: 21
				},
				options: [],
				express: [],
				order: false,
				header: {},
				batchShipmentModal: false,
				modal2: false,
				expressInfo: false,
				result: []
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.limit,
				order_status: 21
			}
			this.loadData()
			this.loadList()
			this.getToken()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			// 上传头部token
			getToken() {
				let token = localStorage.token

				this.header['access-token'] = token;
			},
			uploadSuccess1(res) {
				if (res.code == 1) {
					this.changeModal()
					this.loadList()
					this.$message.success({
						message: res.msg
					});
				} else {
					this.$message.error({
						message: res.msg
					});
				}
			},
			loadData() {
				this.axios.post('/supplier/data/listLogisticsForSelect').then(res => {
					this.express = res.data.list
					this.loadList()
				}).catch(() => {
				})
			},
			changeModal() {
				this.batchShipmentModal = false;
			},
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = true
				let res = ''

				// 店铺列表
				res = await this.axios.get('/supplier/data/listStoreForOrderSearch', {})
				this.options = res.data

				res = await this.axios.post('/supplier/order/list', this.item)
				this.list = res.data.list.data
				this.total = res.data.list.total

				this.isLoad = false
			},
			open(id) {
				this.isLoad = !this.isLoad
				this.axios.get('/supplier/order/detail', {
					params: {
						id: id
					}
				}).then(res => {
					this.isLoad = !this.isLoad
					this.form = {
						id: id,
						goods: res.data.detail.goods
					}
					this.order = res.data.detail
					this.dialogFormVisible = true
				})
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Indent/list.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.limit = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {

				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			async send() {
				// this.isLoad = !this.isLoad
				let res = ''
				try {
					var _this = this
					this.axios.post('/supplier/order/sendShip', {
						id: this.form.id,
						form: {
							express_id: this.form.express_id,
							express_company: this.form.express_id ? (this.express.find(function (item) {
								return _this.form.express_id == item.id
							})).express_name : '',
							express_sn: this.form.express_sn
						}
					}).then(res => {
						this.$message.success({
							message: '发货成功'
						});
						this.dialogFormVisible = false
						this.loadList()
					}) .catch((e) => {
						this.isLoad = false
					}).finally(() => {
						this.isLoad = false
					})
				} catch (res) {
				}

			},
			confirmcancel: function (id) {
				this.$router.push({
					path: '/Indent/list.html#cancel',
					query: {
						id: id
					}
				});
			},
			copy() {
				var clipboard = new Clipboard('.copy-text')
				clipboard.on('success', e => {
					this.$message.success({
						message: '复制成功',
						showClose:false
					});
					// 释放内存
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					// 不支持复制
					this.$message.danger({
						message: '该浏览器不支持自动复制',
						showClose:false
					});
					// 释放内存
					clipboard.destroy()
				})
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);

				this.axios.post('/supplier/order/listExport', this.item)
						.then(res => {
							this.isLoad = false
							if (res.code == 1) {
								import('@/vendor/Export2Excel.js').then(excel => {
									var expCellName = res.data.expCellName
									var tHeader = []
									var filterVal = []
									for (var i in expCellName) {
										tHeader.push(expCellName[i])
										filterVal.push(i)
									}
									const expTableData = res.data.expTableData
									const data = this.formatJson(filterVal, expTableData)
									const merges = res.data.merges
									var d = new Date()
									var year = d.getFullYear()
									var month = d.getMonth()
									var date = d.getDate()
									var hour = d.getHours()
									var minute = d.getMinutes()
									var second = d.getSeconds()
									month = month < 10 ? '0' + month : month
									date = date < 10 ? '0' + date : date
									hour = hour < 10 ? '0' + hour : hour
									minute = minute < 10 ? '0' + minute : minute
									second = second < 10 ? '0' + second : second
									excel.export_json_to_excel({
										header: tHeader,
										// merges: merges,
										data,
										filename: '订单导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
			push: function (id) {
				this.isLoad = true
				this.axios.post('supplier/order/push', {
					id: id,
				}).then(res => {
					this.isLoad = false
					this.$message.success({
						message: res.msg
					});
				}).catch(() => {
					this.isLoad = false
				})
			},
			openLogistics: function (id) {
				this.axios.post('/supplier/order/express', {
					id: id
				}).then((res) => {
					if (res.code == 1) {
						this.expressInfo = res.data.express
						this.result = res.data.express.list;
						this.modal2 = true
					} else {
						this.$message.error(res.msg);
					}
				}).catch(() => {
					this.isLoad = false
				})
			},
		}
	}
</script>
<style scoped>
	.list-box {
		width: 100%;
		background-color: #FFF;
	}

	.list-box .list-box-title {
		width: 100%;
		height: 50px;
		background-color: #f8f8f8;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		margin-bottom: 30px;
	}

	.list-box-title span {
		width: 1px;
		flex-grow: 1;
		display: flex;
		justify-content: center;
	}

	.list-box-title span:first-child {
		flex-grow: 2;
		justify-content: space-between;
		text-indent: 40px;
	}

	.list-box .list-box-content {
		width: 100%;
		border: 1px solid #e5e5e5;
	}

	.list-box-content .list {
		width: 100%;
	}

	.list .list-title {
		width: 100%;
		height: 64px;
		background-color: #f7f7f7;
		padding-left: 30px;
		box-sizing: border-box;
		line-height: 64px;
		color: #9f8e8e;
	}

	.list-title span:first-child {
		font-weight: bold;
		margin-right: 20px;
		color: black;
	}

	.list .list-content-box {
		border-bottom: 1px solid #e5e5e5;
		margin: 0 20px;
	}

	.list-content-box .list-content {
		display: flex;
		flex-wrap: nowrap;
	}


	.list-content span {
		line-height: 1.5;
	}

	.list-content .different-box {
		flex-grow: 2;
		border-left: none !important;
	}

	.different-box .different {
		width: 100%;
		height: 120px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
	}

	.different>div {
		display: flex;
		width: 1px;
		flex-grow: 1;
		justify-content: center;
	}

	.different .thumb {
		display: flex;
		flex-direction: row !important;
		align-items: center;
	}

	.different .goods-text {
		display: flex;
		flex-direction: column;
		margin-left: 20px;
	}

	.text-line {
		line-height: 50px !important;
	}

	.list-content>div {
		width: 1px;
		flex-grow: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		border-left: 1px solid #e5e5e5;
	}

	.list .list-booton {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.list-booton span {
		font-weight: 600;
	}

	.list-booton-edit {
		color: #0027e3;
		cursor: pointer;
	}
</style>
